import requestWrapper from "../utils/requestWrapper";
import { IGenericResponse, IRequestParams } from "@/services/interfaces";

export default async (data: IRequestParams): Promise<IGenericResponse> => {
  const request = {
    url: "/api/cart",
    method: "GET",
    params: data.params,
  };

  return await requestWrapper(request);
};
